export default () => {
  const now = new Date();
  now.setDate(now.getDate() + 0.1667); // 4 horas
  return Math.round(now.getTime() / 1000);
};
